import React, { useRef } from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { insights } from '../data/content';
import { SmartLink } from './SmartLink';
export function Insights() {
  const trackRef = useRef<HTMLUListElement>(null);
  const scrollBy = (direction: -1 | 1) => {
    trackRef.current?.scrollBy({
      left: direction * 340,
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-white py-20" aria-labelledby="insights-heading" data-id="element-639" data-mp="xliydjyv21tj">
      <div className="mx-auto max-w-shell px-6" data-id="element-640" data-mp="xjo9xvodrrkp">
        <h2 id="insights-heading" className="display text-center text-[32px] font-semibold text-ink sm:text-[40px]" data-id="element-641" data-mp="12lneh8vuwuj8">
          Insights for smarter business growth.
        </h2>

        <ul ref={trackRef} className="no-scrollbar mt-12 flex snap-x snap-mandatory gap-6 overflow-x-auto pb-2" data-id="element-642" data-mp="1cb6yihvb2ufo">
          {insights.map(item => <li key={item.title} className="w-[290px] shrink-0 snap-start sm:w-[286px] lg:w-[calc((100%-72px)/4)]" data-id="element-643" data-mp="jtch1ujz1osi">
              <SmartLink href="/blog" className="group flex h-full flex-col" data-id="element-644" data-mp="yfojv3s6dcrj">
                <img src={item.image} alt={item.alt} className="h-[168px] w-full rounded-[10px] object-cover" data-id="element-645" data-mp="tfiz87kboqiy" />
                <p className="mt-4 text-[12px] font-medium uppercase tracking-[0.06em] text-ink-muted" data-id="element-646" data-mp="klnuv1r0z44d">
                  {item.tag}
                </p>
                <h3 className="mt-2 text-[17px] font-semibold leading-[1.3] tracking-[-0.02em] text-ink transition-colors duration-150 ease-out group-hover:text-brand" data-id="element-647" data-mp="ao9fz6kr2ne6">
                  {item.title}
                </h3>
                <p className="mt-2 text-[14px] leading-[1.5] text-ink-muted" data-id="element-648" data-mp="1ocutexkk6nv">{item.copy}</p>
              </SmartLink>
            </li>)}
        </ul>

        <div className="mt-10 flex justify-center gap-3" data-id="element-649" data-mp="2013bc4l6wxde">
          <button type="button" onClick={() => scrollBy(-1)} aria-label="Previous insights" className="flex h-10 w-10 items-center justify-center rounded-full border border-canvas-line text-ink transition-colors duration-150 ease-out hover:bg-canvas-warm" data-id="element-650" data-mp="1w2nhbgqoyoqh">
            <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-651" data-mp="3gl7v5a86fa47" />
          </button>
          <button type="button" onClick={() => scrollBy(1)} aria-label="Next insights" className="flex h-10 w-10 items-center justify-center rounded-full border border-canvas-line text-ink transition-colors duration-150 ease-out hover:bg-canvas-warm" data-id="element-652" data-mp="3km1jg4pj6qxm">
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-653" data-mp="348guj5bvl6r" />
          </button>
        </div>
      </div>
    </section>;
}